import './wa-stub';

import Environment from './helpers/src/environment.js';
import Utils from './helpers/src/utils.js';
import Obj from './helpers/src/obj.js';
import Window from './helpers/src/window.js';
import Dimensions from './helpers/src/dimensions.js';
import EventHandlers from './helpers/src/event-handlers.js';
import DomHandlers from './helpers/src/dom-handlers.js';
import GlobalHandlers from './helpers/src/global-handlers.js';
import Device from './helpers/src/device.js';
import Browser from './helpers/src/browser.js';
import DomHelpers from './helpers/src/dom-helpers.js';
import StyleHelpers from './helpers/src/style-helpers.js';
import UrlConverter from './helpers/src/url-converter.js';
import Ajax from './helpers/src/ajax.js';
import Dropdowns from './toolbars-manager/src/toolbar/src/dropdown/src/dropdowns.js';

import Services from './services/src/services.js';

new BonaEditorSingle();

if (window.WA)
{
  window.WA.BonaEditor = window.BEditor;
}

if (!BEditor.domHelpers.$('idBonaEditorContextContainer'))
{
  document.body.insertAdjacentHTML('beforeend', '<div id="idBonaEditorContextContainer"></div>');
}

if (!window.BEditor.Dialogs)
{
  window.BEditor.Dialogs = {};
}

if (!window.BEditor.Dropdowns)
{
  window.BEditor.Dropdowns = {};
}

window.BEditor.createRegistrableTimeout = createRegistrableTimeout;

export default function BonaEditor()
{
  return window.BEditor;
}


function BonaEditorSingle()
{
  let pThis = this;

  window.BEditor = pThis;
  global.BEditor = window.BEditor;


  pThis.environment = new Environment();
  pThis.utils = new Utils();

  pThis.domHandlers = new DomHandlers();

  pThis.device = new Device();
  pThis.browser = new Browser();

  pThis.obj = new Obj();
  pThis.window = new Window();
  pThis.dimensions = new Dimensions();
  pThis.eventHandlers = new EventHandlers();

  pThis.globalHandlers = new GlobalHandlers();

  pThis.domHelpers = new DomHelpers();
  pThis.styleHelpers = new StyleHelpers();
  pThis.urlConverter = new UrlConverter();
  pThis.ajax = new Ajax();
  pThis.services = new Services();

  pThis.dropdowns = new Dropdowns();

  pThis.UI = window.WA.UI;
  pThis.AdminPanel = window.WA.AdminPanel;
  pThis.ModelAccessor = window.WA.ModelAccessor;
  pThis.Admin = window.WA.Admin;



  //=====================================================================================

  if (!pThis.UI)
  {
    pThis.UI =
      {
        FileSortType:
          {
            SortByDateDes: ''
          }
      }
  }

  //=====================================================================================

  pThis.Dispose = pThis.eventHandlers.createHandlers(pThis, { id: 'Dispose' });
  pThis.RenderComplete = pThis.eventHandlers.createHandlers(pThis, { id: 'RenderComplete' });
  pThis.BonaEditorReady = pThis.eventHandlers.createHandlers(pThis, { id: 'BonaEditorReady', type: pThis.eventHandlers.Type.Long });

  let isDragDropUploaderWatching = false,
      pEditor,
      resources,
      bonaEditorReadyTM = null;

  pThis.refreshThemeResources = refreshThemeResources;
  pThis.isPageAdminViewMode = function () { return (BEditor.AdminPanel && BEditor.AdminPanel.PageMode && BEditor.AdminPanel.PageMode.Mode() === BEditor.AdminPanel.PageModeType.View); };
  pThis.isPageAdminEditMode = function () { return (BEditor.AdminPanel && BEditor.AdminPanel.PageMode && BEditor.AdminPanel.PageMode.Mode() === BEditor.AdminPanel.PageModeType.Edit); };
  pThis.onCopy = onCopy;
  pThis.webkitCopy = webkitCopy;
  pThis.addAppOutHandler = addAppOutHandler;
  pThis.appOutHandlerOnFocus = appOutHandlerOnFocus;
  pThis.appOutHandlerOnBlur = appOutHandlerOnBlur;
  pThis.getRealBackgroundForEventDetails = getRealBackgroundForEventDetails;
  pThis.startDragDropUploaderWatch = startDragDropUploaderWatch;
  pThis.stopDragDropUploaderWatch = stopDragDropUploaderWatch;
  pThis.clearRealBackgroundForEvents = clearRealBackgroundForEvents;


  function startDragDropUploaderWatch (newPEditor)
  {
    if (newPEditor !== pEditor || !isDragDropUploaderWatching)
    {
      pEditor = newPEditor;
      isDragDropUploaderWatching = true;
    }
  }


  function stopDragDropUploaderWatch ()
  {
    if (isDragDropUploaderWatching)
    {

      isDragDropUploaderWatching = false;
    }
  }


  function init()
  {
    if (BEditor.AdminPanel)
    {
      BEditor.AdminPanel.ContentAreaLoaded.addHandler(addOnCopyHandler);
    }

    //for test only!!!
    bonaEditorReadyTM = setTimeout(fireBonaEditorReady, 5000);
  }


  function fireBonaEditorReady()
  {
    //TODO:DIME fire it when it really will be ready
    pThis.BonaEditorReady.fireHandlers();
  }


  function refreshThemeResources ()
  {
    BEditor.Config.refreshThemeResources();
  }


  function addOnCopyHandler ()
  {
    if (BEditor.browser.isEdge)
    {
      return;
    }

    if (BEditor.browser.isWebKit && !BEditor.browser.isWebKitSafari || BEditor.browser.isEdge)
    {
      BEditor.globalHandlers.addGlobalHandler('document', 'copy', webkitCopy, 'GlobalOnCopyHandlerForEditor', { 'excludeWindowPartName': 'nmEditorIFrame_' });
    }
    else if (BEditor.browser.isGecko || (BEditor.browser.isIE && BEditor.browser.isIE > 9) || BEditor.browser.isWebKitSafari)
    {
      BEditor.globalHandlers.addGlobalHandler('document', 'copy', onCopy, 'GlobalOnCopyHandlerForEditor', { 'excludeWindowPartName': 'nmEditorIFrame_' });
    }
    else if (BEditor.browser.isIE)
    {
      BEditor.globalHandlers.addGlobalHandler('document', 'copy', onCopy, 'GlobalOnCopyHandlerForEditor', { 'excludeWindowPartName': 'nmEditorIFrame_' });
    }
  }


  function onCopy (e, win)
  {
    let i,
        selection = win.getSelection(true),
        currentRange,
        elements,
        checkAllBlockTags = /^(body|p|h[1-6]|div|pre|li|blockquote|center|dt|dd|td|th|address|marquee)$/i,
        parentElement;

    if (selection && selection.rangeCount === 1)
    {
      currentRange = selection.getRangeAt(0);
    }

    if (selection && currentRange)
    {
      //if (BEditor.Browser.isIE)
      //{
      parentElement = currentRange.commonAncestorContainer;

      while (parentElement && !checkAllBlockTags.test(parentElement.nodeName.toUpperCase()))
      {
        parentElement = parentElement.parentNode;
      }

      if (parentElement)
      {
        parentElement.setAttribute('data-wacopycontent', 1);
        elements = parentElement.getElementsByTagName('*');

        for (i = 0; i < elements.length; i++)
        {
          elements[i].setAttribute('data-wacopycontent', 1);
        }
      }

      if (BEditor.browser.isIE)
      {
        BEditor.copyDataText = currentRange.toString();

        if (BEditor.copyDataText)
        {
          BEditor.copyDataText = BEditor.copyDataText.replace(/\s+/g, '');
        }
      }

      setTimeout(function ()
      {
        win.document.body.removeAttribute('data-wacopycontent');

        let elements = win.document.body.querySelectorAll('[data-wacopycontent]');

        for (let i = elements.length; i--;)
        {
          elements[i].removeAttribute('data-wacopycontent');
        }
      }, 50);

      BEditor.isLocalClipboard = true;
      addAppOutHandler();
    }
  }


  function webkitCopy (e, win)
  {
    let i,
        selection = win.getSelection(),
        currentSelection,
        currentRange,
        timeStamp = (new Date()).getTime(),
        saveRangeStructure,
        domHelperElement,
        ancestorContainer,
        pEditor,
        absElement,
        blockTags = /^\s*<(?:BODY|ADDRESS|BLOCKQUOTE|CENTER|DIV|FIELDSET|FORM|H[1-6]|ISINDEX|MENU|OL|P|PRE|TABLE|UL)[\s>]/i,
        slaveTagsStr = 'AREA|CAPTION|COL|COLGROUP|TBODY|TD|TFOOT|TH|THEAD|TR|COMMAND|DD|DT|LI|FIGCAPTION|LEGEND|OPTGROUP|OPTION|PARAM|RP|RT|SUMMARY|SOURCE',
        slaveTags = new RegExp('(?:^\\s*<(' + slaveTagsStr + ')[\\s>]|<\/(' + slaveTagsStr + ')>\\s*$)', 'i'),
        styleTags = /^(?:B|BDO|BIG|EM|FONT|I|S|SMALL|SPAN|STRIKE|STRONG|SUB|SUP|U)$/i,
        slaveMasterTags =
        {
          'AREA': [ 'MAP' ],
          'CAPTION': [ 'TABLE' ],
          'COL': [ 'TABLE' ],
          'COLGROUP': [ 'TABLE' ],
          'TBODY': [ 'TABLE' ],
          'TD': [ 'TABLE' ],
          'TFOOT': [ 'TABLE' ],
          'TH': [ 'TABLE' ],
          'THEAD': [ 'TABLE' ],
          'TR': [ 'TABLE' ],
          'COMMAND': [ 'MENU' ],
          'DD': [ 'DL' ],
          'DT': [ 'DL' ],
          'LI': [ 'UL', 'OL', 'DIR' ],
          'FIGCAPTION': [ 'FIGURE' ],
          'LEGEND': [ 'FIELDSET' ],
          'OPTGROUP': [ 'SELECT' ],
          'OPTION': [ 'SELECT', 'DATALIST'],
          'PARAM': [ 'APPLET', 'OBJECT' ],
          'RP': [ 'RUBY' ],
          'RT': [ 'RUBY' ],
          'SUMMARY': [ 'DETAILS' ],
          'SOURCE': [ 'AUDIO', 'VIDEO' ]
        },
        matchedTags,
        currentSlaveTag,
        parentElement = null,
        webkitCopyParentsBegin = '',
        webkitCopyParentsEnd = '',
        webkitCopyHTML,
        copyMarker;

    if (selection && selection.rangeCount === 1)
    {
      currentRange = selection.getRangeAt(0);
    }

    if (currentRange)
    {
      ancestorContainer = currentRange.commonAncestorContainer;

      if (ancestorContainer && ancestorContainer.nodeName === 'DIV' && ancestorContainer.getAttribute('data-waelementhidecursor'))
      {
        if (ancestorContainer.ownerDocument && ancestorContainer.ownerDocument.editorId)
        {
          pEditor = BEditor.EditorsManager.getEditorById(ancestorContainer.ownerDocument.editorId);

          if (pEditor)
          {
            absElement = pEditor.isRangeElementPositionAbsolute();
            webkitCopyHTML = absElement ? absElement.outerHTML : null;
          }
        }
      }
      else
      {
        domHelperElement = win.document.createElement('DIV');
        domHelperElement.appendChild(currentRange.cloneContents());
        webkitCopyHTML = domHelperElement.innerHTML;
        domHelperElement = null;

        parentElement = ancestorContainer;

        while (parentElement && parentElement.nodeType === 1 && parentElement.nodeName.toUpperCase() !== 'BODY' && parentElement.innerHTML.replace(/(?:^\s+|\s+$)/g, '') === webkitCopyHTML)
        {
          webkitCopyHTML = parentElement.outerHTML;
          parentElement = parentElement.parentNode;
        }
      }
    }

    if (webkitCopyHTML != null && webkitCopyHTML !== '')
    {
      matchedTags = slaveTags.exec(webkitCopyHTML);

      if (matchedTags && matchedTags.length > 1)
      {
        currentSlaveTag = matchedTags[1] || matchedTags[2];

        if (currentSlaveTag)
        {
          currentSlaveTag = currentSlaveTag.toUpperCase();
          setParentElement();

          while (parentElement)
          {
            addParentParts();

            for (i = 0; i < slaveMasterTags[currentSlaveTag].length; i++)
            {
              if (parentElement.nodeName === slaveMasterTags[currentSlaveTag][0])
              {
                parentElement = null;
                break;
              }
            }

            if (parentElement)
            {
              parentElement = parentElement.parentNode;
            }
          }
        }
      }
      else if (!blockTags.test(webkitCopyHTML))
      {
        setParentElement();

        while (parentElement && styleTags.test(parentElement.nodeName))
        {
          addParentParts();
          parentElement = parentElement.parentNode;
        }
      }

      if (window.localStorage && webkitCopyParentsBegin.length + webkitCopyHTML.length + webkitCopyParentsEnd.length < 1048576)
      {
        delete BEditor['webKitClipboard'];

        try
        {
          localStorage['webKitClipboard'] = JSON.stringify(
          {
            'timeStamp': timeStamp,
            'parentsBegin': webkitCopyParentsBegin,
            'HTML': webkitCopyHTML,
            'parentsEnd': webkitCopyParentsEnd

          });
        }
        catch (err)
        {
          delete localStorage['webKitClipboard'];
          BEditor['webKitClipboard'] = JSON.stringify(
          {
            'timeStamp': timeStamp,
            'parentsBegin': webkitCopyParentsBegin,
            'HTML': webkitCopyHTML,
            'parentsEnd': webkitCopyParentsEnd

          });
        }
      }
      else
      {
        if (window.localStorage)
        {
          delete localStorage['webKitClipboard'];
        }

        BEditor['webKitClipboard'] = JSON.stringify(
        {
          'timeStamp': timeStamp,
          'parentsBegin': webkitCopyParentsBegin,
          'HTML': webkitCopyHTML,
          'parentsEnd': webkitCopyParentsEnd

        });
      }

      BEditor.isWebKitClipboard = true;
      addAppOutHandler();

      currentSelection = win.getSelection();

      if (currentSelection && currentRange)
      {
        saveRangeStructure =
        {
          'startContainer': currentRange.startContainer,
          'startOffset': currentRange.startOffset,
          'endContainer': currentRange.endContainer,
          'endOffset': currentRange.endOffset
        };

        copyMarker = win.document.createElement('DIV');
        copyMarker.setAttribute('style', 'position: absolute; left: 0; top: 0; width: 1px; height: 1px; overflow: hidden; opacity: 0;');
        copyMarker.setAttribute('data-wawebkitcopycontainer', '1');
        copyMarker.innerHTML = '<abbr data-wawebkitcopymarker="' + timeStamp + '">&nbsp;</abbr>';
        win.document.body.appendChild(copyMarker);

        if (copyMarker)
        {
          copyMarker.insertBefore(currentRange.cloneContents(), copyMarker.firstElementChild);
          currentRange.selectNodeContents(copyMarker);
        }
      }

      currentSelection.removeAllRanges();
      currentSelection.addRange(currentRange);

      setTimeout(function ()
      {
        let i,
            currentSelection,
            currentRange,
            elements = win.document.body.querySelectorAll('DIV[data-wawebkitcopycontainer]');

        for (i = elements.length; i--;)
        {
          if (elements[i] && elements[i].parentNode)
          {
            elements[i].parentNode.removeChild(elements[i]);
          }
        }

        currentSelection = win.getSelection();
        currentRange = win.document.createRange();

        if (currentSelection && currentRange)
        {
          currentRange.setStart(saveRangeStructure.startContainer, saveRangeStructure.startOffset);
          currentRange.setEnd(saveRangeStructure.endContainer, saveRangeStructure.endOffset);
          currentSelection.removeAllRanges();
          currentSelection.addRange(currentRange);
        }
      }, 50);
    }
    else
    {
      if (e)
      {
        if (window.localStorage)
        {
          delete localStorage['webKitClipboard'];
        }

        delete BEditor['webKitClipboard'];
        BEditor.isWebKitClipboard = false;
      }
      else
      {
        alert('Please use Ctrl+C to Copy');
      }
    }

    function setParentElement ()
    {
      parentElement = currentRange.commonAncestorContainer;

      while (parentElement && parentElement.nodeType !== 1)
      {
        parentElement = parentElement.parentNode;
      }
    }

    function addParentParts ()
    {
      let parentParts = parentElement.outerHTML.match(/^(<[^>]+>).*?(<[^>]+>)$/);

      if (parentParts && parentParts.length === 3)
      {
        webkitCopyParentsBegin = parentParts[1] + webkitCopyParentsBegin;
        webkitCopyParentsEnd += parentParts[2];
      }
    }
  }


  function addAppOutHandler ()
  {
    BEditor.globalHandlers.addGlobalHandler('window', 'focus', appOutHandlerOnFocus, 'BonaEditorGlobalFocusInAllWindow', {});
    BEditor.globalHandlers.addGlobalHandler('window', 'blur', appOutHandlerOnBlur, 'BonaEditorGlobalBlurInAllWindow', {});
  }


  function appOutHandlerOnFocus (e, win)
  {
    if (BEditor.addAppOutHandlerTM) clearTimeout(BEditor.addAppOutHandlerTM);
  }


  function appOutHandlerOnBlur (e, win)
  {
    if (BEditor.addAppOutHandlerTM) clearTimeout(BEditor.addAppOutHandlerTM);
    BEditor.addAppOutHandlerTM = setTimeout(appOutHandlerOnBlurDo, 17);
  }


  function appOutHandlerOnBlurDo ()
  {
    BEditor.isLocalClipboard = false;
    BEditor.isWebKitClipboard = false;
  }


  let iFrameForEventsBackground,
      lastIFrameURLForEventsBackground,
      realBackgroundForEvents = {},
      bodyStylesForEvent = {};


  function getRealBackgroundForEventDetails (callBack, bodyTransferStyles)
  {
    let eventURLField,
        eventURL,
        eventKey,
        hIFrameContainer,
        testURL = /\/event-\d+/i;

    eventURLField = BEditor.domHelpers.$('eventDetailsMain_viewUrl', BEditor.environment.topWindow.contentarea);

    if (eventURLField)
    {
      eventURL = (BEditor.browser.isIE && BEditor.browser.isIE < 9) ? eventURLField.innerText : eventURLField.textContent;
    }
    else
    {
      eventURLField = BEditor.domHelpers.$('eventDetailsMain_editViewUrl', BEditor.environment.topWindow.contentarea);

      if (eventURLField)
      {
        eventURL = eventURLField.value;
      }
    }

    if (!eventURL || !testURL.test(eventURL))
    {
      if (lastIFrameURLForEventsBackground)
      {
        callBack(lastIFrameURLForEventsBackground, bodyStylesForEvent);
      }
      else
      {
        callBack(eventURL ? '##WA_NEWEVENTWITHEMPTYURL##' : null, bodyStylesForEvent);
      }

      return;
    }

    eventKey = eventURL.replace(/https?:\/\//, '');
    eventURL += ((eventURL.indexOf('?') === -1) ? '?' : '') + 'websiteviewmode=2&skipCollecting=true';

    if (realBackgroundForEvents[eventKey])
    {
      callBack(realBackgroundForEvents[eventKey]);
      return;
    }
    else if (lastIFrameURLForEventsBackground)
    {
      callBack(lastIFrameURLForEventsBackground, bodyStylesForEvent);
      return;
    }

    if (!iFrameForEventsBackground)
    {
      hIFrameContainer = document.createElement('DIV');
      hIFrameContainer.id = 'idEditorIFrameContainer_RealBackgroundForEventDetails';
      hIFrameContainer.setAttribute('style', 'position: absolute; left: -3700px; top: -3700px; z-index: 1; width: 1px; height: 1px; overflow: hidden;');
      document.body.appendChild(hIFrameContainer);
      hIFrameContainer.innerHTML = '<iframe id="idEditorIFrame_RealBackgroundForEventDetails" name="nmEditorIFrame_RealBackgroundForEventDetails" src="' + eventURL + '" style="width: 800px; height: 600px;"></iframe>';
      iFrameForEventsBackground = window.frames['nmEditorIFrame_RealBackgroundForEventDetails'];
    }
    else
    {
      iFrameForEventsBackground.isRealBackgroundForEventDetailsOldIFrameContent = true;
      iFrameForEventsBackground.location = eventURL;
    }

    step1();

    function step1 ()
    {
      if (BEditor.browser.isIE)
      {
        iFrameForEventsBackground = window.frames['nmEditorIFrame_RealBackgroundForEventDetails'];

        if (!iFrameForEventsBackground)
        {
          setTimeout(step1, 17);
        }
      }

      if (iFrameForEventsBackground && !iFrameForEventsBackground.isRealBackgroundForEventDetailsOldIFrameContent && iFrameForEventsBackground.BonaPage && iFrameForEventsBackground.BonaPage.addPageStateHandler)
      {
        BEditor.domHandlers.addPageParsedHandler(step2, {window: iFrameForEventsBackground});
      }
      else
      {
        setTimeout(step1, 17);
      }
    }

    function step2 ()
    {
      let k,
          parentElement = iFrameForEventsBackground.document.body.querySelector('[class~=WaGadgetEventsStateDetails]'),
          element;

      if (parentElement)
      {
        element = parentElement.querySelector('[class~=gadgetEventEditableArea]');

        if (element)
        {
          lastIFrameURLForEventsBackground = BEditor.styleHelpers.getElementRealBackground(element, iFrameForEventsBackground);

          for (k in bodyTransferStyles)
          {
            if (bodyTransferStyles.hasOwnProperty(k))
            {
              bodyStylesForEvent[k] = BEditor.styleHelpers.getElementStyle(element, k);
            }
          }
        }
      }

      if (!lastIFrameURLForEventsBackground)
      {
        lastIFrameURLForEventsBackground = { 'backgroundColor': '#FFFFFF' };
      }

      callBack(lastIFrameURLForEventsBackground, bodyStylesForEvent);
    }
  }


  function clearRealBackgroundForEvents ()
  {
    realBackgroundForEvents = {};
    lastIFrameURLForEventsBackground = null;
    bodyStylesForEvent = {};
  }


  function createDebugArea (l, r, t, b, w, h)
  {
    let topWin = BEditor.environment.topWindow;

    if (!topWin.editorDebugArea)
    {
      topWin.editorDebugArea = null;
      topWin.editorDebugArea = document.createElement('TEXTAREA');
      topWin.editorDebugArea.style.position = 'absolute';
      topWin.editorDebugArea.style[(l != null) ? 'left' : 'right'] = ((l != null) ? l : r) + 'px';
      topWin.editorDebugArea.style[(b != null) ? 'bottom' : 'top'] = ((b != null) ? b : t) + 'px';
      topWin.editorDebugArea.style.width = w + 'px';
      topWin.editorDebugArea.style.height = h + 'px';
      topWin.editorDebugArea.style.zIndex = 65535;
      appendDebugArea();
    }

    function appendDebugArea ()
    {
      if (topWin.document && topWin.document.body && topWin.document.body.appendChild)
      {
        topWin.document.body.appendChild(topWin.editorDebugArea);

        topWin.setEditorDebugMessage = function (msg)
        {
          if (BEditor.environment.topWindow.editorDebugArea)
          {
            BEditor.environment.topWindow.editorDebugArea.value += msg;
          }
        };
      }
      else
      {
        setTimeout(appendDebugArea, 37);
      }
    }
  }

  function createDebugStraightedge (isX, isY)
  {
    let i,
        str,
        dig,
        win = BEditor.environment.topWindow;

    if (isX && !win.straightedgeX)
    {
      win.straightedgeX = win.document.createElement('DIV');
      win.straightedgeX.style.position = 'fixed';
      win.straightedgeX.style.left = '0px';
      win.straightedgeX.style.top = '0px';
      win.straightedgeX.style.width = '2000px';
      win.straightedgeX.style.height = '27px';
      win.straightedgeX.style.zIndex = '37777';
      win.straightedgeX.style.overflow = 'hidden';
      win.straightedgeX.style.borderBottom = '1px solid #CCCCCC';

      str = '';

      for (i = 0; i < 200; i++)
      {
        //dig = (i > 0) ? (i * 10).toString().split('').join('<br>') : i;
        str += '<div style="position: relative; width: 10px; height: 20px; float: left; padding-top: 7px; font-family: Arial; font-size: 8px; font-weight: bold;"><div style="position: relative; left: -4px; transform: rotate(270deg);">' + (i * 10) + '</div><div style="position: absolute; left: 0px; bottom: 0px; width: 1px; height: 10px; background-color: #FF0000;"></div></div>'
      }

      win.straightedgeX.innerHTML = str;
      win.document.body.appendChild(win.straightedgeX);
    }

    if (isY && !win.straightedgeY)
    {
      win.straightedgeY = win.document.createElement('DIV');
      win.straightedgeY.style.position = 'fixed';
      win.straightedgeY.style.left = '0px';
      win.straightedgeY.style.top = '0px';
      win.straightedgeY.style.width = '27px';
      win.straightedgeY.style.height = '1000px';
      win.straightedgeY.style.zIndex = '37777';
      win.straightedgeY.style.overflow = 'hidden';
      win.straightedgeY.style.borderRight = '1px solid #CCCCCC';

      str = '';

      for (i = 0; i < 100; i++)
      {
        str += '<div style="position: relative; width: 16px; height: 10px; padding-right: 11px; font-family: Arial; font-size: 8px; font-weight: bold; text-align: right;"><div style="position: relative; top: -4px;">' + (i * 10) + '</div><div style="position: absolute; right: 0px; top: 0px; width: 10px; height: 1px; background-color: #FF0000;"></div></div>'
      }

      win.straightedgeY.innerHTML = str;
      win.document.body.appendChild(win.straightedgeY);
    }
  }


  function dispose()
  {
    if (bonaEditorReadyTM) clearTimeout(bonaEditorReadyTM);

    pThis.Dispose.fireHandlers();

    pThis.Dispose = null;
    pThis.BonaEditorReady = null;
    pThis.GetEditorSiteStructureFailed = null;

    resources = null;
  }

  if (BEditor.AdminPanel)
  {
    BEditor.AdminPanel.AdminPanelReady.addHandler(init);
    BEditor.AdminPanel.Dispose.addHandler(dispose);
  }
  else
  {
    BEditor.domHandlers.addPageParsedHandler(init);
    BEditor.domHandlers.addHandler(window, 'unload', dispose);
  }
}


function createRegistrableTimeout()
{
  var timeoutsRegistry = [];

  function setRegisteredTimeout(func, timeout)
  {
    var tm = setTimeout(func, timeout);

    timeoutsRegistry.push(tm);

    return tm;
  }

  function disposeTimeouts ()
  {
    var i,
        timeout;

    for (i = 0; i < timeoutsRegistry.length; i++)
    {
      timeout = timeoutsRegistry[i];

      if(timeout)
      {
        clearTimeout(timeout);
      }
    }
  }

  setRegisteredTimeout.disposeTimeouts = disposeTimeouts;

  return setRegisteredTimeout;
}


